import { USER_ROLE_ANONYMOUS } from 'common/userRoles';

import { SR_API_ACTION_UPDATE_USER_SETTINGS } from 'api/actionTypes';

export default async function updateSettings({ state, apiClient }, userSettings) {
  const userRoles = state.get(['currentUser', 'roles']);
  const isAnonymous = userRoles.includes(USER_ROLE_ANONYMOUS);

  if (isAnonymous) {
    for (const userSettingKey of Object.keys(userSettings)) {
      state.set(['currentUser', 'settings', userSettingKey], userSettings[userSettingKey]);
    }
    state.commit();
  } else {
    await apiClient.postWithState({
      action: SR_API_ACTION_UPDATE_USER_SETTINGS,
      state: state,
      payload: {
        userSettings,
      },
      onSuccess(userUpdated) {
        state.set(['currentUser'], {
          ...state.get(['currentUser']),
          ...userUpdated,
        });
      },
    });
  }
}
